module.exports = __webpack_public_path__ + "static/img/lead-inter-asset-girl-2.7e0f1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lead-inter-asset-girl-2.png
// module id = B2MA
// module chunks = 1